module.exports = __webpack_public_path__ + "img/loginBG.db166cda.png";